// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__gdXKL","text":"Pagination_text__3_pdL"};